export const cloneArray = (arr) => arr.map((p) => ({ ...p }));
export const cloneItem = (item) => ({ ...item });
